"use client";

import { Button, buttonVariants } from "@watt/ui/components/ui/button";
import Link from "next/link";
import { useState } from "react";
import type { QuickLoginTestAccount } from "../../quick-login/accounts";
import { DevQuickLogin } from "./dev-quick-login";
import { UserLoginForm } from "./user-login-form";

type LoginMode = "quick" | "manual";

type LoginFlowProps = {
  accounts: readonly QuickLoginTestAccount[];
  showQuickLogin: boolean;
};

export function LoginFlow({ accounts, showQuickLogin }: LoginFlowProps) {
  const [mode, setMode] = useState<LoginMode>("quick");

  const isQuickMode = showQuickLogin && mode === "quick";

  return (
    <>
      <div className="flex flex-col space-y-2 text-center">
        <h1 className="font-semibold text-2xl tracking-tight">Welcome!</h1>
        <p className="text-muted-foreground text-sm">
          {isQuickMode
            ? "Choose a test profile or sign in manually."
            : "Enter your email and password to continue."}
        </p>
      </div>

      {isQuickMode ? (
        <>
          <DevQuickLogin accounts={accounts} />
          <Button
            className="w-full"
            onClick={() => {
              setMode("manual");
            }}
            type="button"
            variant="ghost"
          >
            Sign in with email and password
          </Button>
        </>
      ) : (
        <>
          <UserLoginForm />
          {showQuickLogin ? (
            <Button
              className="w-full"
              onClick={() => {
                setMode("quick");
              }}
              type="button"
              variant="ghost"
            >
              Back to quick login
            </Button>
          ) : null}
        </>
      )}

      <div className="flex flex-col space-y-2">
        <Link
          className={buttonVariants({ variant: "link" })}
          href="/authentication/forgot-password"
        >
          Forgot password?
        </Link>
      </div>
    </>
  );
}
